const styles = (theme) => ({
  appModal: {
    zIndex: 500,
    background: theme.colors.bgWhite,
    position: 'fixed',
    overflow: 'hidden',
  },
  customModalIframe: {
    border: 'none',
  },
});

export default styles;
